import React, { useEffect, useState } from "react";
import { useEducation } from "../../../hooks/useEducation";
import ClassCard from "./ClassCard";
import "./CourseClassList.css";

const CourseClassList = ({
  courseId,
  courseName,
  enrollmentId,
  progressPercentage,
}) => {
  const [classes, setClasses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);

  const classesPerPage = 6;

  const { fetchCourse } = useEducation();

  useEffect(() => {
    const fetchClassesForCourse = async () => {
      setLoading(true);
      try {
        const courseDetails = await fetchCourse(courseId);

        if (courseDetails && Array.isArray(courseDetails.classes)) {
          setClasses(courseDetails.classes);
        } else {
          setClasses([]);
        }
      } catch (err) {
        console.error("Failed to fetch classes:", err);
        setError("Failed to load classes for this course");
      } finally {
        setLoading(false);
      }
    };

    if (courseId) {
      fetchClassesForCourse();
    }
  }, [courseId, fetchCourse]);

  if (loading) {
    return <div className="loading-classes">Loading classes...</div>;
  }

  if (error) {
    return <div className="error-classes">{error}</div>;
  }

  if (classes.length === 0) {
    return (
      <div className="no-classes">No classes available for this course</div>
    );
  }

  const totalPages = Math.ceil(classes.length / classesPerPage);

  const currentClasses = classes.slice(
    currentPage * classesPerPage,
    (currentPage + 1) * classesPerPage
  );

  const goToNextPage = () => {
    setCurrentPage((prevPage) => (prevPage + 1) % totalPages);
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage - 1 + totalPages) % totalPages);
  };

  return (
    <div className="course-classes-list">
      <div className="classes-grid">
        {currentClasses.map((classItem) => (
          <ClassCard
            key={classItem.id}
            classItem={classItem}
            courseId={courseId}
            enrollmentId={enrollmentId}
            progressPercentage={progressPercentage}
          />
        ))}
      </div>

      {totalPages > 1 && (
        <div className="pagination-controls">
          <button
            className="pagination-button"
            onClick={goToPrevPage}
            disabled={currentPage === 0}
          >
            Previous
          </button>
          <span className="pagination-info">
            Page {currentPage + 1} of {totalPages}
          </span>
          <button
            className="pagination-button"
            onClick={goToNextPage}
            disabled={currentPage === totalPages - 1}
          >
            Next
          </button>
        </div>
      )}
    </div>
  );
};

export default CourseClassList;
